var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-fullscreen modal-filter-details fade",
      attrs: {
        id: "modal-add-talent",
        role: "dialog",
        "aria-labelledby": "shortlist-modal-label",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: { "data-backdrop": "true", "data-keyboard": "true" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                {
                  staticClass: "modal-title",
                  attrs: { id: "shortlist-modal-label" },
                },
                [
                  _vm.$userIsAdmin
                    ? [_vm._v("Add " + _vm._s(_vm.$starLabelPlural))]
                    : _vm.$userIsManager
                    ? [
                        _vm._v(
                          _vm._s(_vm.$t("Apply")) +
                            " For " +
                            _vm._s(_vm.$starLabelPlural)
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c("talent-filtering", {
                  attrs: {
                    "scroll-target": "#modal-add-talent .modal-body",
                    booking: this.booking,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-lg btn-primary",
                    attrs: {
                      type: "button",
                      click: _vm.handleSaveAdditionalTalentCallback,
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Save\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-lg btn-danger pull-left",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Cancel")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }